import { render } from "./edgePage.vue?vue&type=template&id=5c8bf892"
import script from "./edgePage.vue?vue&type=script&lang=js"
export * from "./edgePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__